import {ComponentFactoryResolver, ComponentRef, Injectable, Type} from '@angular/core';
import {InjectionsService} from '../injections.service';
import {Observable, of} from 'rxjs';

@Injectable()
export class InjectionService {
    public componentFactories: Array<ComponentRef<any>>;

    constructor(private componentFactoryResolver: ComponentFactoryResolver,
                private injectionsService: InjectionsService) {
        this.componentFactories = new Array<ComponentRef<any>>();
    }

    /**
     *
     */
    public delete<T>(componentRef: ComponentRef<T>): void {
        const component = this.componentFactories.find((componentFactory) => componentFactory === componentRef);
        this.injectionsService.get().remove(this.injectionsService.get().indexOf(component.hostView));
        this.componentFactories.splice(this.componentFactories.indexOf(component), 1);
    }

    /**
     *
     */
    public post<T>(componentType: Type<T>): Observable<ComponentRef<T>> {
        const componentRef = this.injectionsService.get().createComponent(this.componentFactoryResolver.resolveComponentFactory(componentType));
        this.componentFactories.push(componentRef);

        return of(componentRef);
    }
}
